import getCategoryById from "../../utilities/getCategoryById.js";

export default function transactionCategoryRetriever(transaction){
	const categories = transaction.getCategories();
	let isExpenseCategoryGroup = true;
	for(let categoryId of categories) {
		const category = getCategoryById(categoryId);
		if(category) {
			isExpenseCategoryGroup = category.isExpenseCategory();
		}
	}
	return isExpenseCategoryGroup;
}
